import SuppliersConstants from '@/store/modules/usersManagement/suppliers/constants';

export default {
  [SuppliersConstants.mutationTypes.setSuppliers](state, suppliers) {
    const localState = state;

    localState.suppliers = suppliers;
  },
  [SuppliersConstants.mutationTypes.setIsLoading](state, value) {
    const localState = state;

    localState.isLoading = value;
  },
  [SuppliersConstants.mutationTypes.setSuppliersTotal](state, value) {
    const localState = state;

    localState.suppliersTotal = value;
  },

  [SuppliersConstants.mutationTypes.setPaginationInfo](state, value) {
    const localState = state;

    localState.paginationInfo = value;
  },

  [SuppliersConstants.mutationTypes.setFilterQuery](state, value) {
    const localState = state;

    localState.filterQuery = value;
  },
  [SuppliersConstants.mutationTypes.setPaginationInfoPageNumber](state, value) {
    const localState = state;
    localState.paginationInfo.pageNumber = value;
  },
};
